import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12.0023,
			cy: 12.0022,
			rx: 12.0023,
			ry: 12.0022,
			fill: "#5699CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.28516 20.2537C5.47271 17.9438 8.56867 16.5029 12.0012 16.5029C15.4337 16.5029 18.5296 17.9438 20.7172 20.2537C18.5296 22.5637 15.4337 24.0045 12.0012 24.0045C8.56867 24.0045 5.47271 22.5637 3.28516 20.2537Z",
			fill: "#F6F6F6"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_129_25386)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 8.00195,
				y: 5.00098,
				width: 8.00151,
				height: 10.0019,
				rx: 4.00076,
				fill: "#F6F7F6"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.9708 8.50195C15.9912 8.66578 16.0017 8.83268 16.0017 9.00204V11.0024C16.0017 13.2119 14.2105 15.0031 12.001 15.0031C11.8316 15.0031 11.6648 14.9926 11.501 14.9722V12.0026H13.0013V10.5023C13.0013 9.39755 13.8969 8.50195 15.0016 8.50195H15.9708Z",
				fill: "url(#paint0_linear_129_25386)"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_129_25386",
			x1: 12.3448,
			y1: 15.0031,
			x2: 12.3448,
			y2: 8.50195,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#CFDFFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5699CD"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_129_25386",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 8.00151,
				height: 10.0019,
				fill: "white",
				transform: "translate(8.00195 5.00098)"
			})
		})] })
	]
});
export default SvgUserIcon;
